import Button from "../../Misc/Button";
import "./index.css";
import classNames from "classnames";
import { useState } from "react";
import { AddressChange, Subscription } from "../../Types";
import { sleep } from "../../Utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { callMinaSidorApi, getSessionId } from "../../Utils/api";
import config from "../../config";

type Props = {
  subscriptions: Subscription[];
}

export default function SettingsView({ subscriptions }: Props) {
  const [activeView, setActiveView] = useState<string>("payment")

  return (
    <div>
      <div className="settings-button-container">
        <Button isSmaller={true} isActive={activeView === "payment"} isPrimary={true} label="Betalsätt" onClick={() => setActiveView("payment")} />
        <Button isSmaller={true} isActive={activeView === "moving"} isPrimary={true} label="Flyttanmälan" onClick={() => setActiveView("moving")} />
        <Button isSmaller={true} isActive={activeView === "info"} isPrimary={true} label="Allmän information" onClick={() => setActiveView("info")} />
      </div>
      {activeView === "payment" && <PaymentView subscriptions={subscriptions} />}
      {activeView === "moving" && <MovingView />}
      {activeView === "info" && <GeneralInfoView />}
    </div>
  );
}

function GeneralInfoView() {
  return (
    <div className="settings-view">
      <div className="general-info">
        <p>För att lämna klagomål vänligen maila till: {config.supportEmail} eller ring {config.supportPhone}. {config.mailingAddress ? `Du kan också skicka brev till ${config.mailingAddress}.` : null}</p>
        <p>För information gällande tvistlösning vänligen vänd er till Energimarknadsinspektionen <a href="http://www.ei.se" target="_blank" rel="noopener noreferrer">www.ei.se</a> eller allmänna reklamationsnämnden <a href="http://www.arn.se" target="_blank" rel="noopener noreferrer">www.arn.se</a>.</p>
        <p>För information gällande oberoende användarrådgivning kan ni vända er till er kommunala energirådgivare eller till Statens energimyndighet på <a href="http://www.energimyndigheten.se" target="_blank" rel="noopener noreferrer">www.energimyndigheten.se</a> och <a href="http://www.energiochklimatradgivningen.se" target="_blank" rel="noopener noreferrer">www.energiochklimatradgivningen.se</a>.</p>
        <p>För att jämföra elpriser gå in på det oberoende jämförelseverktyget <a href="http://www.elpriskollen.se" target="_blank" rel="noopener noreferrer">www.elpriskollen.se</a>.</p>
        <p>Alla kundens rättigheter finns även på vår webbplats via länken <a href={config.termsUrl} target="_blank" rel="noopener noreferrer">{config.termsUrl}</a>. Om du som kund önskar få informationen på något annat vis kan du alltid ringa oss på {config.supportPhone} eller maila oss på {config.supportEmail} så hjälper vår kundservice er med alla era frågor och funderingar. Vi kan även skicka hem villkor och rättigheter till din hemadress om du önskar. Våra avtalsvillkor finns på <a href={config.termsUrl} target="_blank" rel="noopener noreferrer">{config.termsUrl}</a>.</p>
        <p>På <a href="http://www.ei.se/kundflex" target="_blank" rel="noopener noreferrer">www.ei.se/kundflex</a> hittar du information om hur du använder din el flexibelt enligt efterfrågeflexibilitet.</p>
      </div>
    </div>
  );
}

function MovingView() {
  const [address, setAddress] = useState<AddressChange>({
    address: '',
    careOf: '',
    city: '',
    date: '',
    dayPhone: '',
    email: '',
    mobile: '',
    postalCode: ''
  });
  const [isBusy, setBusy] = useState(false);
  const [isAdressChanged, setIsAdressChanged] = useState(false)

  async function submit(address: AddressChange) {
    if (isBusy) {
      return;
    }
    setBusy(true);
    setIsAdressChanged(true)


    try {
      await callMinaSidorApi('post', `/zavann/create_future_address_change.php`, {
        change_date: address.date,
        day_phone: address.dayPhone,
        home_phone: "",
        cell_phone: address.mobile,
        email: address.email,
        address1: address.address,
        zip_code: address.postalCode,
        city: address.city,
        careof: address.careOf
      }); // Gör riktiga anropet.
    } catch (error) {
      alert("Något gick fel.");
      console.error("Error changing address", error);
      setBusy(false);
      return;
    }

    setBusy(false);
  }

  function onChange(update: Partial<AddressChange>) {
    setAddress(address => ({ ...address, ...update }));
  }

  return (
    <div className="settings-view">
      {isAdressChanged ? <ChangedAdress isBusy={isBusy} /> :
        <form className="moving">
          <label>
            Datum för flytt
            <input type="date" value={address.date} min={new Date().toLocaleDateString("sv-SE")} onChange={event => onChange({ date: event.currentTarget.value })} />
          </label>
          <label>
            Ny stad
            <input type="text" value={address.city} onChange={event => onChange({ city: event.currentTarget.value })} />
          </label>
          <label>
            Ny postkod
            <input type="text" maxLength={5} value={address.postalCode} onChange={event => onChange({ postalCode: event.currentTarget.value })} />
          </label>
          <label>
            Ny adress
            <input type="text" value={address.address} onChange={event => onChange({ address: event.currentTarget.value })} />
          </label>
          <label>
            C/o <input type="text" value={address.careOf} onChange={event => onChange({ careOf: event.currentTarget.value })} />{" "}
          </label>
          <label>
            Telefon under dagen
            <input type="tel" value={address.dayPhone} onChange={event => onChange({ dayPhone: event.currentTarget.value })} />
          </label>
          <label>
            Mobiltelefon
            <input type="tel" value={address.mobile} onChange={event => onChange({ mobile: event.currentTarget.value })} />
          </label>
          <label>
            E-mail
            <input type="email" value={address.email} onChange={event => onChange({ email: event.currentTarget.value })} />
          </label>
          <Button
            isActive={false}
            isPrimary={false}
            isSmaller={true}
            label={"Spara ändringar"}
            onClick={event => {
              submit(address);
              event.preventDefault();
              return false;
            }} />
        </form>}</div>)
}

function ChangedAdress({ isBusy }) {


  return (
    <div className="changed-adress">
      {isBusy ? <FontAwesomeIcon style={{ color: config.colors.primary }} icon={faPaperPlane} /> : <FontAwesomeIcon style={{ color: config.colors.primary }} icon={faCheck} />}
      {isBusy ? <h2>Skickar...</h2> : <h2>Skickat!</h2>}
      {isBusy ? <p>Vänligen vänta medan vi skickar iväg din flyttanmälan.</p> : <p>Vi har nu tagit emot din flyttanmälan. Har du några frågor eller liknande, kontakta vår support!</p>}
    </div>
  )
}

export enum PaymentOptions {
  PDF = 5,
  Autogiro = 4,
  Pappersfaktura = 1,
}

type PaymentViewProps = {
  subscriptions: Subscription[];
}

function PaymentView({ subscriptions }: PaymentViewProps) {

  const [isSaving, setSaving] = useState(false);
  const [paymentOption, setPaymentOption] = useState<PaymentOptions>(null);
  const [selectedSiteId, setSelectedSiteId] = useState<number>(subscriptions[0]?.id ?? null);

  async function savePaymentMethod(paymentId: PaymentOptions) {
    if (isSaving) {
      return;
    }

    setSaving(true);

    try {
      await callMinaSidorApi('post', `/zavann/add_payment_type.php?siteId=${selectedSiteId}&paymentTypeId=${paymentId}`);
      alert("Din ändring är registrerad!");
    } catch (error) {
      console.error("Error changing payment method to %s", paymentId, error)
      alert("Något gick fel, kolla så alla uppgifter stämmer och försök igen, eller kontakta kundservice");
    }

    setSaving(false);
  }

  return (
    <div className="settings-view">
      <form
        className="payment"
        onSubmit={event => {
          event.preventDefault();
          event.stopPropagation();
          savePaymentMethod(paymentOption);
          return false;
        }}>
        <label className="payment-site-picker">
          Välj abonnemang
          <select
            value={selectedSiteId ?? ""}
            onChange={event => setSelectedSiteId(Number(event.currentTarget.value))}
          >
            {subscriptions.map(sub => (
              <option key={sub.id} value={sub.id}>{sub.adress}</option>
            ))}
          </select>
        </label>
        <label className="payment-site-picker">
          Betalsätt
          <select
            value={paymentOption ?? ""}
            onChange={event => setPaymentOption(Number(event.currentTarget.value) as PaymentOptions)}
          >
            <option value={PaymentOptions.PDF}>PDF-faktura</option>
            <option value={PaymentOptions.Autogiro}>Autogiro</option>
            <option value={PaymentOptions.Pappersfaktura}>Pappersfaktura</option>
          </select>
        </label>
        <Button
          isActive={false}
          isPrimary={false}
          isSmaller={true}
          label={isSaving ? "Sparar ändringar..." : "Spara ändringar"}
          onClick={(e) => {
            console.log("ändrat")
          }}
        />
      </form>
    </div>)
}